import "./StatCards.css";

export default function StatCards({ stats, onOpen }) {

    const getStatusClass = (count) => {
        if (count === 0) return "neutral";
        if (count <= 3) return "warning";
        return "danger";
    };

    return (
        <div className="stats">

            <div className="stat-card">
                <p>Total</p>
                <h2>{stats.total}</h2>
            </div>

            <div
                className={`stat-card clickable ${getStatusClass(stats.cameOnTimeCount)}`}
                onClick={() => onOpen("came_on_time")}
            >
                <p>Came On Time</p>
                <h2>{stats.cameOnTimeCount}</h2>
            </div>

            <div
                className={`stat-card clickable ${getStatusClass(stats.lateCount)}`}
                onClick={() => onOpen("late")}
            >
                <p>Late</p>
                <h2>{stats.lateCount}</h2>
            </div>

            <div
                className={`stat-card clickable ${getStatusClass(stats.leftEarlyCount)}`}
                onClick={() => onOpen("left_early")}
            >
                <p>Left Early</p>
                <h2>{stats.leftEarlyCount}</h2>
            </div>

            <div
                className={`stat-card clickable ${getStatusClass(stats.leftOnTimeCount)}`}
                onClick={() => onOpen("left_on_time")}
            >
                <p>Left On Time</p>
                <h2>{stats.leftOnTimeCount}</h2>
            </div>

            <div
                className={`stat-card clickable ${getStatusClass(stats.absentCount)}`}
                onClick={() => onOpen("absent")}
            >
                <p>Absent</p>
                <h2>{stats.absentCount}</h2>
            </div>

        </div>
    );
}
